import { CommonModule } from '@angular/common';
import { Component, computed, inject, model, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Segment, SegmentOption } from '@malirang/front-share';
import { CenterStore } from 'apps/client/src/stores/center/center.store';
import { injectNavigationEnd } from 'ngxtension/navigation-end';

/**
 * 초대/가입신청 내역
 */
@Component({
  selector: 'app-center-join-layout',
  templateUrl: './center-join.layout.html',
  imports: [CommonModule, Segment, RouterOutlet],
})
export class CenterJoinLayout implements OnInit {
  readonly router = inject(Router);
  readonly navigationEnd$ = injectNavigationEnd();
  readonly centerStore = inject(CenterStore);

  segments = computed<SegmentOption[]>(() => [
    {
      label: '초대',
      value: 'invite',
      count: this.count()?.pendingInviteLogsCount,
    },
    {
      label: '가입 신청',
      value: 'request',
      count: this.count()?.pendingJoinLogsCount,
    },
  ]);

  segment = model('invite');

  count = this.centerStore.count;

  ngOnInit(): void {
    this.setSegment();

    this.navigationEnd$.subscribe({
      next: () => {
        this.setSegment();
      },
    });
  }

  setSegment() {
    const segment = this.router.url.split('/').pop();
    if (segment === 'invite' || segment === 'request') {
      this.segment.set(segment);
    }
  }

  segmentChange() {
    this.router.navigate(['/center/join', this.segment()]);
  }
}
